<template>
  <div class="login-container">
    <!-- 欢迎界面内容 -->
    <div class="welcome-container">
      <!-- <div class="logos"><span style="font-size: 50px;">八</span></div> -->
      <h1>欢迎使用客服系统</h1>
      <p class="description">高效、安全、智能的企业管理解决方案，助力您的业务飞速发展</p>
      <a href="https://t.me/tsnnc" class="contact-link" target="_blank">联系客服 @tsnnc</a>

    </div>

    <!-- 登录表单 -->
    <div class="login-card">
      <h2 class="login-title">登录</h2>
      <div class="login-body">
        <div class="input-group">
          <label for="username" class="input-label">用户名</label>
          <input id="username" v-model="username" type="text" class="login-input" placeholder="请输入用户名"
            :disabled="loading" @input="handleInput" @keyup.enter="handleLogin" />
        </div>
      </div>
      <div class="login-footer">
        <button class="login-btn login-btn-confirm" @click="handleLogin" :disabled="loading">
          <span v-if="loading" class="loading-spinner"></span>
          <span v-else>登录</span>
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import { getRequestParams, encodeToBase64 } from '@/utils/getPrams.js';
import api from '../../api/api'
export default {
  data() {
    return {
      username: '',
      authValue: '',
      tokenValue: '',
      authObj: null,
      loading: false
    }
  },
  created() {

    // 根据URL参数判断是否显示ConfirmInput
    this.checkUrlParams()
  },
  methods: {
    handleInput() {
      // 可以添加输入验证逻辑
    },
    async checkUrlParams() {
      try {
        const urlParams = getRequestParams();

        if (urlParams) {
          const decodedStr = Buffer.from(decodeURIComponent(urlParams), 'base64').toString();
          //console.log(decodedStr);

          // 2. 解析为 JSON 对象（让数据更易读取和使用）
          this.authObj = JSON.parse(decodedStr);
          //console.log(this.authObj);

          if (!this.authObj) {
            return;
          }

          if (!this.authObj.robotId || !this.authObj.userId || !this.authObj.token) {
            this.loading = false;
            return this.$message.error('参数不完整');
          }

          // 验证authObj的合法性
          if (this.authObj.type == 1 || this.authObj.type == "1") {
            // 登录处理
            this.username = this.authObj.robotName;
          } else {
            console.error('authObj验证失败:', this.authObj);
            this.$message.error('参数不合法，请重新尝试');
          }
        } else {

        }

      } catch (error) {
        console.error('JSON解析错误:', error);
        this.$message.error('参数解析失败');
      }
    },

    //数据脾气：auth参数在登录页面，token参数在聊天页面
    async shouquanAuth() {
      try {
        const ip = await this.getIP();
        const ipInfo = await api.getIPInfo(ip);
        //console.log('IP信息:', ipInfo);

        // 检查URL参数并根据情况显示ConfirmInput
        let map = {
          userId: this.authObj.userId,
          robotId: this.authObj.robotId,
          uuid: this.authObj.token,
          "ip": ipInfo.ip,
          "device": navigator.userAgent,
          "type": this.detectEnvironment(),
          "country": ipInfo.country,
          "city": ipInfo.city,
          "timezone": ipInfo.timezone,
          "region": ipInfo.country_code
        };

        const authRes = await api.sendAuth(map);
        //console.log('授权发送结果:', authRes);

        if (authRes.data.code == 200 || authRes.data.code == 2000) {
          let map = {
            userId: this.authObj.userId,
            robotId: this.authObj.robotId,
            uuid: this.authObj.token,
          }
          this.requestgetAuthStatus(map)
        } else {
          this.loading = false;
          this.$message.error('参数失败 ' + authRes.data.code);
        }
      } catch (error) {
        this.loading = false;

        this.$message.error('参数失败，请重试');
      }
    },

    // 轮训接口
    requestgetAuthStatus(map) {
      const startTime = Date.now();
      const MAX_DURATION = 10 * 60 * 1000; // 10分钟，单位毫秒
      const INTERVAL = 3000; // 轮训间隔，3秒

      const intervalId = setInterval(() => {
        // 检查是否超过10分钟
        const elapsedTime = Date.now() - startTime;
        if (elapsedTime >= MAX_DURATION) {
          //console.log('轮训已超过10分钟，自动停止');
          clearInterval(intervalId);
          return;
        }

        api.getAuthStatus(map).then(res => {
          // 如果未授权，显示ConfirmInput
          if (res.data.code == 200) {
            let result = res.data.result;
                // 登录成功后清除轮训
              clearInterval(intervalId);
            // 保存token到localStorage
            if (result && result.token) {
              localStorage.setItem('sx-token', result.token);
            }
            // 模拟登录请求
            localStorage.setItem('isLoggedIn', 'true');
              this.loading = false;
              // 获取当前URL参数
              const urlParams = getRequestParams();
              const decodedStr = Buffer.from(decodeURIComponent(urlParams), 'base64').toString();

              // 2. 解析为 JSON 对象（让数据更易读取和使用）
              let authObj = JSON.parse(decodedStr);
              authObj.type = 2;
              authObj.token = result.token;
              const encodedParams = encodeToBase64(authObj);
              //console.log(encodedParams);
              
              // 跳转到聊天页面，保留查询参数
              this.$router.push({
                path: '/chat?' + encodedParams //保留所有原始查询参数
              });


          
          } else if (res.data.code == 500) {
            clearInterval(intervalId);
            this.loading = false;
            this.$confirm(res.data.message + '\n是否重新尝试？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              // 用户点击确定按钮后的操作
              //console.log('用户确认了操作');
              window.location.href = 'https://t.me/' + this.authObj.robotName;
            }).catch(() => {
              // 用户点击取消按钮后的操作
              //console.log('用户取消了操作');
            });
          }
        })
      }, INTERVAL);

    },

    // URL参数解析 - 支持hash模式

    // 方法1：最简单的获取公网IP
    async getIP() {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        return data.ip;
      } catch (error) {
        console.error('获取IP失败:', error);
        return null;
      }
    },
    detectEnvironment() {
      const ua = navigator.userAgent;
      const isMobile = /Android|iPhone|iPad/i.test(ua);

      if (isMobile) {
        return 'mobile';
      } else {
        return 'pc';
      }
    },

    handleLogin() {

      try {
        if (!this.authObj) {
          return this.$message.error('参数不合法');
        }
        //console.log(this.authObj);

        // 设置加载状态
        this.loading = true;

        // 检查必要参数是否存在
        if (!this.authObj.robotId || !this.authObj.userId || !this.authObj.token) {
          this.loading = false;
          return this.$message.error('参数不完整');
        }

        this.shouquanAuth()
      } catch (error) {
        this.loading = false;
        console.error('登录处理错误:', error);
        this.$message.error('参数不合法，请重试');
      }
    },
    validateAuthObj(authObj) {
      // 首先检查 authObj 是否为对象
      if (!authObj || typeof authObj !== 'object') {
        return false;
      }

      // 将 type 转换为数字类型进行比较，支持字符串"1"/"2"和数字1/2
      const type = Number(authObj.type);

      // 检查 type 是否存在且为 1 或 2
      if (type !== 1 && type !== 2) {
        return false;
      }

      // 基础必填字段（所有 type 都需要）
      const basicRequiredFields = ['robotId', 'userId', 'token'];
      for (const field of basicRequiredFields) {
        if (!authObj[field]) {
          return false;
        }
      }

      // type == 1 时，robotName 也必填
      if (type === 1 && !authObj.robotName) {
        return false;
      }

      // 所有检查通过
      return true;
    }


  }
}
</script>

<style lang="less" scoped>
body {
  -webkit-text-size-adjust: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.login-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: auto;
  padding: 40px 20px;

  /* 添加柔和的背景光效 */
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 800px;
    height: 800px;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 70%);
    transform: translate(-50%, -50%);
    z-index: 0;
  }

  /* 确保内容在最上层 */
  >* {
    position: relative;
    z-index: 1;
  }
}

.welcome-container {
  max-width: 600px;
  padding: 0 20px 30px;
  color: white;
  text-align: center;


  @media (max-width: 768px) {
    padding: 0 10px 20px;
    margin-bottom: 25px;
  }
}

.logos {
  margin-bottom: 25px;
  opacity: 0.9;
}

.welcome-container h1 {
  font-size: 32px;
  margin-bottom: 12px;
  font-weight: 600;
  opacity: 0.95;

  @media (max-width: 480px) {
    font-size: 26px;
  }
}

.description {
  font-size: 15px;
  margin-bottom: 25px;
  opacity: 0.85;
  line-height: 1.5;

  @media (max-width: 480px) {
    font-size: 14px;
  }
}

.contact-link {
  display: inline-block;
  padding: 8px 22px;
  background-color: rgba(255, 255, 255, 0.15);
  color: white;
  text-decoration: none;
  border-radius: 25px;
  margin-bottom: 30px;
  font-weight: 500;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);

  &:hover {
    background-color: rgba(255, 255, 255, 0.25);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
}

.features {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 35px;
  padding: 0 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-bottom: 28px;
  }
}

.feature {
  background-color: rgba(255, 255, 255, 0.08);
  padding: 20px 18px;
  border-radius: 16px;
  backdrop-filter: blur(15px);
  min-width: 130px;
  flex: 1;
  max-width: 160px;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);

  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 768px) {
    max-width: 100%;
    min-width: auto;
    width: 85%;
  }
}

.feature-icon {
  font-size: 28px;
  margin-bottom: 10px;
}

.feature-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 6px;
  opacity: 0.9;
}

.feature-desc {
  font-size: 13px;
  opacity: 0.75;
  line-height: 1.3;
}

.login-card {
  width: 100%;
  max-width: 400px;
  background-color: rgba(255, 255, 255, 0.98);
  border-radius: 20px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15);
  padding: 30px 32px;
  box-sizing: border-box;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 16px 64px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 480px) {
    padding: 25px 24px;
    border-radius: 16px;
  }
}

.login-title {
  margin: 0 0 22px 0;
  font-size: 22px;
  font-weight: 600;
  color: #444;
  text-align: center;
  opacity: 0.9;
}

.login-body {
  margin-bottom: 22px;
}

.input-group {
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
}

.input-group {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.input-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  margin-bottom: 8px;
  opacity: 0.85;
}

.login-input {
  width: 100%;
  padding: 14px 20px;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  font-size: 15px;
  box-sizing: border-box;
  transition: all 0.3s ease;
  background-color: #fff;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.03);
  color: #333;
  font-family: inherit;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);
    transform: translateY(-1px);
  }

  &:disabled {
    background-color: #f8f8f8;
    color: #999;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #aaa;
    opacity: 0.7;
  }
}

.login-footer {
  display: flex;
  justify-content: center;
}

.login-btn {
  width: 100%;
  padding: 14px 20px;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: inherit;
  letter-spacing: 0.5px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
    box-shadow: none !important;
  }

  &:not(:disabled):hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  }

  &:not(:disabled):active {
    transform: translateY(0);
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  }
}

.login-btn-confirm {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  }
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-right: 10px;
  display: inline-block;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.welcome-container,
.login-card {
  animation: fadeInUp 0.6s ease-out;
  animation-fill-mode: both;
}

.welcome-container {
  animation-delay: 0.1s;
}

.login-card {
  animation-delay: 0.3s;
}
</style>
